import { useRef } from 'react';
import { useListVehiclesHighestBid } from '../hooks';
import { HoverInfoTooltip } from '../../AuctionDetail/components/HoverInfo';
import { useCustomerHoverStateHandlers } from '../../AuctionDetail/hooks';

export const HighBidder = ({ vehicle }) => {
  const { bidder } = useListVehiclesHighestBid(vehicle);
  const { isOpen, handleClose, handleOpen } = useCustomerHoverStateHandlers();
  const ref = useRef(null);

  if (!bidder) {
    return 'N/A';
  }

  return (
    <HoverInfoTooltip
      anchorEl={ref.current}
      initialPage={`/admin/vehicles`}
      isPopoverOpened={isOpen}
      closeTooltip={handleClose}
      showTooltip={false}
      userId={bidder.id}
      tooltipName={bidder.dealership_name}
    >
      <span style={{ cursor: 'pointer' }} ref={ref} onClick={bidder.is_bot ? undefined : handleOpen}>
        {bidder.dealership_name}
      </span>
    </HoverInfoTooltip>
  );
};
